<p-dialog
  class="dialog-affirmation"
  [modal]="true"
  [closable]="true"
  [height]="611"
  [top]="178"
  [(visible)]="showPop"
  [closeOnEscape]="false"
  header="{{ title }}"
  (onHide)="closeAffirmations()"
>
  <div class="user-confirmation-blocking" [hidden]="!blockDialog">
    <span>Loading...</span>
  </div>
  <div class="user-confirmation-content" [ngClass]="{ 'disable-control': loading }">
    <div class="user-confirmation-title">
      <span>
        Please review the details of your request and confirm all entries prior to modify the authority. Something not right? Proceed to
        cancel the request.
      </span>
    </div>
    <div
      class="user-confirmation-lines"
      [ngClass]="{ 'mutually-exclusive-selection': userConfirmationItem.confirmType === 'ME' }"
      *ngFor="let userConfirmationItem of userConfirmationList"
    >
      <div class="user-confirmation-line-title">{{ userConfirmationItem.title }}</div>
      <div
        class="user-confirmation-line-text entry-validation-{{ userConfirmationLabel.accepted }}"
        *ngFor="let userConfirmationLabel of userConfirmationItem.userConfirmationLabelList"
        (click)="toggleUserConfirmationLabelStatus(userConfirmationItem, userConfirmationLabel)"
      >
        <span title="{{ userConfirmationLabel.value }}">{{ userConfirmationLabel.confirmMessage }}</span>
        <i class="csx-common_check" [hidden]="!userConfirmationLabel.accepted"></i>
        <button
          type="button"
          pButton
          label="{{ userConfirmationItem.confirmType === 'ME' ? 'Select' : 'Confirm' }}"
          class="p-button-outlined smaller"
          [hidden]="userConfirmationLabel.accepted"
        ></button>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="user-confirmation-blocking" [hidden]="!blockDialog"></div>
    <button type="button" pButton label="Cancel" (click)="closeAffirmations()" class="w-16rem p-button-outlined"></button>
    <button
      type="button"
      style="margin-left:2px;"
      class="w-16rem"
      pButton
      [disabled]="!allAccepted"
      label="Confirm"
      (click)="submitChangeRequest()"
    ></button>
  </p-footer>
</p-dialog>
